import {
    Condition,
    TextCondition,
    TextConditionType,
    TextOperator,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"
import { TextConditionDTO } from "../../models/dto/conditions/TextCondition"

export const TextConditionDTOType = "#TF.TextFieldCondition"
export enum TextOperatorDTO {
    Contains = "Contains",
    IsEmpty = "IsEmpty",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === TextConditionType
}
const checkIfApplicableDTO = (condition: ConditionDTO): boolean => {
    return condition["@type"] === TextConditionDTOType
}

const parseFromDTO = (condition: TextConditionDTO): TextCondition => {
    if (!checkIfApplicableDTO(condition)) {
        return null
    }
    let result: TextCondition = null
    switch (condition.Operator) {
        case TextOperatorDTO.Contains: {
            if (condition.Value) {
                result = {
                    type: TextConditionType,
                    operator: TextOperator.Contains,
                    value: condition.Value,
                    isLocked: condition.IsLocked,
                }
            }
            break
        }
        case TextOperatorDTO.IsEmpty: {
            result = {
                type: TextConditionType,
                operator: TextOperator.IsEmpty,
                value: null,
                isLocked: condition.IsLocked,
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (
    id: string,
    condition: TextCondition,
): TextConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: TextConditionDTO | null = null
    switch (condition.operator) {
        case TextOperator.Contains: {
            if (condition.value) {
                result = {
                    "@type": TextConditionDTOType,
                    Operator: TextOperatorDTO.Contains,
                    Value: condition.value,
                    IsLocked: condition.isLocked,
                    FieldDefinition: {
                        Id: id,
                    },
                }
            }
            break
        }
        case TextOperator.IsEmpty: {
            result = {
                "@type": TextConditionDTOType,
                Operator: TextOperatorDTO.IsEmpty,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: TextConditionType,
    TypeDTO: TextConditionDTOType,
    checkIfApplicable,
    checkIfApplicableDTO,
    parseFromDTO,
    parseToDTO,
}
export default parser
